export enum NavigationAction {
  BACK_TO_LIST = 'BACK_TO_LIST',
  PREVIOUS = 'PREVIOUS',
  NEXT = 'NEXT',
}
